export default {
  setLoader: false,
  loadingRequestorContactInfo: false,
  loadingEmailData: false,
  showRequestAwsQuestionnaire: true,
  showRequestAwsContacts: false,
  dxcRegions: ['APJ-MEA', 'Americas', 'Europe', 'UKI'],
  regions: ['All Region', 'amer', 'emea', 'eu', 'apac', 'anz'],
  restrictedRegions:[],
  onboardingRecords:[],
  purposes: [
    'Proof of Concept or Prototype(POC)',
    'Production(Prod)',
    'Staging(Stage)',
    'Quality Assurance (QA)',
    'Development (Dev)',
    'Test (Test)',
    'Demonstration (Demo)',
    'Sandbox (SB)',
    'Training'],
  awsServices: ['DXC Gold (CloudOps)', 'DXC Silver'],
  awsSupports: ['Enterprise', 'Business', 'Developer', 'Basic'],
  customers:[],
  emailListHeaders: [
    {
      sortable: true,
      text: 'Actions',
      value: ''
    },
    {
      sortable: true,
      text: 'First Name',
      value: 'Contact_First_Name'
    },
    {
      sortable: true,
      text: 'Last Name',
      value: 'Contact_Last_Name'
    },
    {
      sortable: true,
      text: 'Email Address',
      value: 'Contact_Email_Address'
    }
  ],
  acctOwnerTableHeader: [
    {
      sortable: true,
      text: 'Name',
      value: 'name'
    },
    {
      sortable: true,
      text: 'Phone',
      value: 'phone'
    },
    {
      sortable: true,
      text: 'Email',
      value: 'email'
    }
  ],
  // New Account for New client Page
  newAwsAccount: {
    registrationStep: 'listing', // ie, listing, validation, onboarding, contact
    sfdcId: '',
    searching: false,
    searchMessage: '',
    searchError: false,
    selected: false,
    opportunityName: '',
    workloadTitle: '',
    submittedDate: '',
    oppregStatus: '',
    savingContact: false,
    custName:'',
    custRegion:'', 
    accountRecord: {
      financial: {
        WBS_code: null,
        WBS_expiration_date: null,
        IWO_Reqd: null,
        IWO_Code: null,
        IWO_expiration_date: null
      },
      onboarding: {
        Onboarding_Id: null,
        Acct_ID: null,
        Acct_Exp_Id: null,
        Onboarding_Status: 'New',
        Financial_Id: null,
        Unique_Agreement_Id: null,
        AcctSecurity_Id: null,
        Customer_Id: null,
        Project_Id: null,
        Contact_Id: null,
        Customer_Type: null,
        Acct_name: null,
        Acct_DL: null,
        Date_onboarded: null,
        Last_Date_Validated: null,
        Date_Requested_change: null,
        MP_ID: null,
        Previous_MP_ID: null,
        Managed_Svc: null,
        Acct_status: null,
        Acct_Restricted: null,
        Is_MP: null,
        Acct_Description: null,
        Del_Flag: 0,
        Account_Purpose: null,
        AWS_Support_Type: null,
        Specific_Region: null,
        Specific_Location: null,
        Account_Owners: [],
        CloudCheckr_users: [],
        IAM_Users: [],
        Notification_List: [],
        Financial_Owner: [],
        Customer_Regulations: [],

        Comments: null,
        SaaS: null,
        SaaS_Solution: null,
        AWS_Req_Type:null,
        Restricted_Region_Id: null,
        Tmp_Cust_Name: null, 
        Registration_Id: null,
        GovCloud_Resource_Account: null
      },
      contact: {
        Id: null,
        Contact_First_Name: null,
        Contact_Last_Name: null,
        Contact_Phone: null,
        Contact_Email: null,
        Contact_Title: null,
        Contact_FullName: null
      }
    },
    noDiscount: false
  },
  // AwsAcctListing Component State
  awsAccountListing: {
    registrationStep: 'listing', // ie, listing, validation, onboarding, contact
    selectedWorkload: [],
    loadingWorkloads: false,
    awsListHeaders: [
      {
        sortable: true,
        text: 'Actions',
        value: ''
      },
      {
        sortable: true,
        text: 'Workload Title',
        value: 'Workload_Title'
      },
      {
        sortable: true,
        text: 'OppReg Req Date',
        value: 'OppReg_Req_Date'
      },
      {
        sortable: true,
        text: 'Workload Status',
        value: 'Workload_Status'
      },
      {
        sortable: true,
        text: 'Workload Type',
        value: 'Workload_type'
      }
    ],
    workloads: []
  },

  // awsOppRegistration: {
  //   dxcInternalUsedOnly: '',
  //   workloadTitle: '',
  //   workloadStatus: 'Internal PPA - 23%',
  //   customerName: 'DXC Internal',
  //   sameAsLoggedInUser: false,
  //   loadingContact: false,
  //   contact: {
  //     Id: null,
  //     Contact_First_Name: null,
  //     Contact_Last_Name: null,
  //     Contact_Phone: null,
  //     Contact_Email: null,
  //     Contact_Title: null,
  //     Contact_FullName: null
  //   }
  // },


  // AwsAcctValidation Component State
  awsAccountValidation: {
    wbsCode: null,
    wbsValidating: false,
    wbsValidationMessage: '',
    wbsCodeValidated: false,
    wbsType: null,
    iwoCode: null,
    iwoValidating: false,
    iwoValidationMessage: '',
    iwoCodeValidated: false,
    agreed: false,
    submitting: false,
    savingForLater: false,
    savedForLater: false,
    isPromoCode: null,
    awsCredits: null
  },
  awsAccountOnboarding: {
    valid: false,
    Region: false,
    isLocationSpecific: false,
    requireRegulations: 0,
    regulationsDialog: false,
    Customer_Regulations: [],
    AWS_Purpose: {
      all: [],
      primary: null,
      other: [],
      poc: {
        q1: null,
        q2: null,
        q3: null,
        q4: null,
        q5: null
      }
    },
    Client_Shortname: null,

    // Customer-Region 
    isCustRegion: false,
    custRegionAction: null,
    custRegionId: null,
    fields: {
      Onboarding_Id: null,
      Onboarding_Status: 'New',
      Acct_ID: null,
      Acct_Exp_Id: null,
      Financial_Id: null,
      Unique_Agreement_Id: null,
      AcctSecurity_Id: null,
      Customer_Id: null,
      Project_Id: null,
      Contact_Id: null,
      Customer_Type: null,
      Client_Shortname: null,
      Cust_Shortname:null,
      Tmp_Cust_Name:null,
      Cust_Region: null,
      Customer_Alias: null,
      Acct_name: null,
      Acct_DL: null,
      Date_onboarded: null,
      Last_Date_Validated: null,
      Date_Requested_change: null,
      MP_ID: null,
      Previous_MP_ID: null,
      Managed_Svc: null,
      Acct_status: null,
      Acct_Restricted: null,
      Is_MP: null,
      Acct_Description: null,
      Del_Flag: 0,
      Account_Purpose: null,
      AWS_Support_Type: null,
      Specific_Region: null,
      Specific_Location: null,
      Account_Owners: [],
      CloudCheckr_users: [],
      IAM_Users: [],
      Notification_List: [],
      Financial_Owner: [],
      Customer_Regulations: [],
      Comments: null,
      SaaS: null,
      SaaS_Solution: null,
      AWS_Req_Type: null,
      Restricted_Region_Id: null,
      Registration_Id: null,
      Additional_Acct: null,
      Internal_Individual_Training: null,
      Manager_Name: null,
      Manager_Email: null,
      AWS_Service: null,
      S3_Filename: null,
      Is_Training_Account: 'No',
      GovCloud_Resource_Account: null
    }
  },
  awsAccountContact: {
    accountOwnersHeaders: [
      {
        text: 'Actions',
        value: 'Actions',
        sortable: false,
        align: 'left'
      },
      {
        text: 'Name',
        value:'name'
      },
      {
        text: 'Phone',
        value: 'phone'
      },
      {
        text: 'Email',
        value: 'email'
      }
    ],
    editDialog:false,
    editedIndex: -1,
    acctOwner: {
      name: null,
      phone: null,
      email: null
    },
    submitting: false,
    submitted: false,
    contactStatus: false,
    contactStatusMsg: null,
    Account_Owners: [],
    cloudCheckr: [],
    notificationList: [],
    awsContactValid: true
  },

  requestorContactInfo: {
    emailAddress: null,
    emails: [],
    loadingEmailData: false,
    emailListHeaders: [
      {
        sortable: true,
        text: 'Actions',
        value: ''
      },
      {
        sortable: true,
        text: 'First Name',
        value: 'Contact_First_Name'
      },
      {
        sortable: true,
        text: 'Last Name',
        value: 'Contact_Last_Name'
      },
      {
        sortable: true,
        text: 'Email Address',
        value: 'Contact_Email_Address'
      }
    ],
    newContact: {
      Id: null,
      Contact_First_Name: null,
      Contact_Last_Name: null,
      Contact_Phone: null,
      Contact_Email: null,
      Contact_Title: null,
      Contact_FullName: null
    }
  },
  // ####################################################################### //
  // ##                       EXISTING CLIENT                             ## //
  // ####################################################################### //
  newAwsAcctExistingClient: {
    landing: true,
    registrationStep: 'listing', // ie, listing, validation, onboarding, contact
    isCustomerFound: false,
    isAdditionalAcctSupport: null,
    customers: [],
    masterpayers:[], 
    selectedCustomer: null,
    selectedCustomerAgreement: '',
    dialog:'',
    errorDialog1: false,
    errorDialog2: false,
    agreement: null,
    nextStatus: true,
    existingDialog1: false,

    // modal on AwsCustomOnboardingList
    customOnboardingDialog: false,
    next: true,
    q1: null,
    q2: null,
    OppRegId:'',
    OppregIdValidated: false,
    OppRegIdExistLoading:false,
    OppRegIdExistError: false, 
    OppRegIdExistErrorMessage:[], 
    OppRegIdExistSuccess: false, 
    OppRegIdExistSuccessMessage: [],
    workloads:[],
    projectId: '',

    // data that need to be posted in onboarding-header
    AcctSecurity_Id: null,
    Acct_ID: null,
    Acct_name: null,
    Contact_Id: null,
    Customer_Id: null,
    Customer_Name: null,
    Customer_Alias: null,
    Financial_Id: null,
    MP_ID: null,
    Onboarding_Id: null,
    Project_Id: null,
    Registration_Id: null,
    Unique_Id: null,
    Workload_Status: null,
    Workload_Type: null,
    // data end
    awsAccountListing: {
      selectedWorkload: [],
      loadingAccts: false,
      accountHeaders: [
        {
          sortable: true,
          text: 'Actions',
          value: ''
        },
        {
          sortable: true,
          text: 'Account ID',
          value: 'Acct_ID'
        },
        {
          sortable: true,
          text: 'Account Name',
          value: 'Acct_name'
        },
        {
          sortable: true,
          text: 'Master Payer ID',
          value: 'MP_ID'
        },
        {
          sortable: true,
          text: 'Registration ID',
          value: 'Registration_Id'
        },
        {
          sortable: true,
          text: 'OppReg Status',
          value: 'OppReg_Status'
        },
        {
          sortable: true,
          text: 'Managed Svc',
          value: 'Managed_Svc'
        }
      ],
      existingAccounts: []
    },
    accountRecord: {
      financial: {
        WBS_code: null,
        WBS_expiration_date: null,
        IWO_Reqd: null,
        IWO_Code: null,
        IWO_expiration_date: null,
        awsCredits: null
      },
      onboarding: {
        Onboarding_Id: null,
        Acct_ID: null,
        Acct_Exp_Id: null,
        Financial_Id: null,
        Unique_Agreement_Id: null,
        AcctSecurity_Id: null,
        Customer_Id: null,
        Project_Id: null,
        Contact_Id: null,
        Client_Shortname: null,
        Customer_Type: null,
        Acct_name: null,
        Onboarding_Status: 'New',
        Acct_DL: null,
        Date_onboarded: null,
        Last_Date_Validated: null,
        Date_Requested_change: null,
        MP_ID: null,
        Previous_MP_ID: null,
        Managed_Svc: null,
        Acct_status: null,
        Acct_Restricted: null,
        Is_MP: null,
        Acct_Description: null,
        Del_Flag: 0,
        Account_Purpose: null,
        AWS_Support_Type: null,
        Specific_Region: null,
        Specific_Location: null,
        Account_Owners: [],
        CloudCheckr_users: [],
        IAM_Users: [],
        Notification_List: [],
        Financial_Owner: [],
        Customer_Regulations: [],
        Comments: null,
        SaaS: null,
        SaaS_Solution: null,
        AWS_Req_Type:null,
        Restricted_Region_Id: null,
        Additional_Acct: null,
        WS_Selected: null,
        GovCloud_Resource_Account: null
      },
      contact: {
        Id: null,
        Contact_First_Name: null,
        Contact_Last_Name: null,
        Contact_Phone: null,
        Contact_Email: null,
        Contact_Title: null,
        Contact_FullName: null
      },
      newContact: {
        Id: null,
        Contact_First_Name: null,
        Contact_Last_Name: null,
        Contact_Phone: null,
        Contact_Email: null,
        Contact_Title: null,
        Contact_FullName: null
      }
    }
  },
  // ####################################################################### //
  // ##                       INTERNAL CLIENT                             ## //
  // ####################################################################### //
  newAwsAcctInternalClient: {
    landing: true,
    registrationStep: 'internaltype', // ie, internaltype, validation, onboarding, contact
    customers:[], 
    Customer_Alias:null,
    hasInternalOppregId: null,
    oppId: '',
    loadingCustomers: true,
    generatingOppId: false,
    dxcInternalUsedOnly: '',
    OppregIdValidated: false,
    OppRegIdExistLoading: false,
    OppRegIdExistError: false, 
    OppRegIdExistErrorMessage:[], 
    OppRegIdExistSuccess: false, 
    OppRegIdExistSuccessMessage: [],
    workload: {
      dxcInternalUsedOnly: false,
      // workloadTitle: null,
      // workloadStatus: 'Internal - Tier 1 23% - PPA',
      // customerName: 'DXC Internal',
      sameAsLoggedInUser: false,
      loadingContact: false,
      oppFields: {
        opportunity: {
          Opportunity_Id: null,
          SFDC_Oppty_Name: null,
          SFDC_Sales_Stage: null,
          SignDate: null,
          OpportunityTotalValueUSD: null,
          ESRegion: null,
          Customer_Name: 'DXC Internal',
          Country: null,
          PrimaryESPracticeName: null,
          OpportunityDescription: null,
          OpportunityStatus: null,
          IndustryVertical: null,
          ContractLength: null,
          OpportunityNumber: null,
          Client_ID: null
        },
        account: {
          Client_ID: null,
          Customer_Id: null,
          Customer_Name: null,
          Customer_Region: null,
          Customer_URL: null,
          Customer_Address: null,
          Customer_City: null,
          Customer_State: null,
          Customer_PC: null,
          Industry: null
        },
        requestor: {
          Requestor_Id: null,
          Requestor_First_Name: null,
          Requestor_Last_Name: null,
          Requestor_Phone: null,
          Requestor_Email: null
        },
        header: {
          Oppreg_Header_Notes: null,
          Client_ID: null,
          RFI_RFP: null
        }
      },
      fields: {
        Project_Id: null,
        OppReg_Id: null,
        Registration_Id: null,
        Contact_Id: null,
        Requestor_Id: null,
        SFDC_Id: null,
        Workload_Title: null,
        VMware_Workload: null,
        VMware_License: null,
        VMware_Cust_Deploy: null,
        Workload_type: null,
        PPA_Attestation: null,
        Root_Access: null,
        DXC_Managed_Services: null,
        SaaS: null,
        Initiate_Account_Flag: null,
        Workload_Services_Storage: null,
        Workload_Services_Database: null,
        Workload_Services_App_services: null,
        Workload_Services_Compute: null,
        Workload_Services_Network: null,
        Projected_Monthly_Spend: 0,
        WL_Overall_Objective: null,
        WL_Scope_Bounderies: null,
        WL_App_Transformed: null,
        WL_Next_Pursuit: null,
        OppReg_Project_Notes: null,
        OppReg_Req_Date: null,
        Workload_Status: 'Internal - Tier 1 21% - PPA',
        P_Offering_Agreed: 'Y',
        // answers table
        WL_Q1A: null,
        WL_Q2A: null,
        WL_Q3A: null,
        WL_Q4A: null,
        WL_Q5A: null,
        WL_Q6A: null,
        Attested_By: null,
        DXC_Services: null,
        WL_Q7A: '[]',
        WL_Q8A: null,
        WL_Q9A: null,
        WL_Q10A: null
      },
      contact: {
        Id: null,
        Contact_First_Name: null,
        Contact_Last_Name: null,
        Contact_Email: null,
        Contact_Phone: null
      }
    },
    workloads:[],
    projectId: '',
    custName: 'DXC Internal',
    oppregStatus:'Internal - Tier 1 21% - PPA',
    accountRecord: {
      financial: {
        WBS_code: null,
        WBS_expiration_date: null,
        IWO_Reqd: null,
        IWO_Code: null,
        IWO_expiration_date: null,
        AWS_credits: null
      },
      onboarding: {
        Onboarding_Id: null,
        Acct_ID: null,
        Acct_Exp_Id: null,
        Financial_Id: null,
        Unique_Agreement_Id: null,
        AcctSecurity_Id: null,
        Customer_Id: null,
        Project_Id: null,
        Contact_Id: null,
        Client_Shortname: null,
        Cust_Shortname:null,
        Customer_Type: null,
        Acct_name: null,
        Acct_DL: null,
        Date_onboarded: null,
        Last_Date_Validated: null,
        Date_Requested_change: null,
        MP_ID: null,
        Previous_MP_ID: null,
        Managed_Svc: null,
        Acct_status: null,
        Acct_Restricted: null,
        Is_MP: null,
        Acct_Description: null,
        Del_Flag: 0,
        Onboarding_Status: 'New',
        Account_Purpose: null,
        AWS_Support_Type: null,
        Specific_Region: null,
        Specific_Location: null,
        Account_Owners: [],
        CloudCheckr_users: [],
        IAM_Users: [],
        Notification_List: [],
        Financial_Owner: [],
        Customer_Regulations: [],
        Comments: null,
        SaaS: null,
        SaaS_Solution: null,
        AWS_Req_Type:null,
        Restricted_Region_Id: null,
        Internal_Individual_Training: null,
        S3_Filename: null,
        GovCloud_Resource_Account: null
      },
      contact: {
        Id: null,
        Contact_First_Name: null,
        Contact_Last_Name: null,
        Contact_Phone: null,
        Contact_Email: null,
        Contact_Title: null,
        Contact_FullName: null
      },
      newContact: {
        Id: null,
        Contact_First_Name: null,
        Contact_Last_Name: null,
        Contact_Phone: null,
        Contact_Email: null,
        Contact_Title: null,
        Contact_FullName: null
      }
    }
  },
  
  s3FileUpload: {
    item: '',
    filename: '',
    showDialog: false
  }
}
